import { getIsActiveCustomerContext } from "Auth/Api/Queries/Context/contextUtils";
import { useGetContextsQuery } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { LeaveRegistrationButton } from "Components/Onboarding/shared/LeaveRegistrationButton";
import { LogoutButton } from "Components/Onboarding/shared/LogoutButton";
import { useSwitchContextWithReload } from "Hooks/useSwitchContextWithReload";

// The add-role wizard runs in the freshly created role's context; leaving it means going back to
// the Customer persona, not signing out. A plain navigate can't do that — the route gate bounces
// an Onboarding role context straight back into the wizard — so this is a real context switch.
export const SwitchToCustomerButton = () => {
  const { data } = useGetContextsQuery();
  const { switchContext, isSwitching } = useSwitchContextWithReload();

  const customerContext = data?.contexts.find(getIsActiveCustomerContext);

  if (!customerContext) {
    return <LogoutButton />;
  }

  const { identityUserPublicID } = customerContext;

  return (
    <LeaveRegistrationButton
      onClick={() => switchContext({ identityUserPublicID })}
      isDisabled={isSwitching}
    />
  );
};
